module.exports = __webpack_public_path__ + "img/red-pie.257899a9.svg";